import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=29ba022e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=29ba022e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ba022e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ba022e')) {
      api.createRecord('29ba022e', component.options)
    } else {
      api.reload('29ba022e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=29ba022e&scoped=true&", function () {
      api.rerender('29ba022e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2po2wJ9001te8/JS/comp/PopupBox.vue"
export default component.exports